<template>
    <div class="match-info">
        <div class="match-content">
            <div class="match-name home-name">{{ matchInfo.home_name }}</div>
            <img class="mr-16 img-48" :src="matchInfo.home_logo" alt="fail" />
            <div class="match-score">{{ matchInfo.home_score }}</div>
            <div class="info-center">
                <div class="time-name">
                    <span class="time-date">
                        {{
                            matchInfo.kickoff_time &&
                                matchInfo.kickoff_time.substring(0, 10)
                        }}
                    </span>
                    <span class="time-event-name" :title="matchInfo.event_name">
                        {{
                            matchInfo.event_name
                        }}
                    </span>
                </div>
                <div class="surplus-time">{{ matchInfo.time || 'vs' }}</div>
            </div>
            <div class="match-score">{{ matchInfo.away_score }}</div>
            <img class="ml-16 img-48" :src="matchInfo.away_logo" alt="fail" />
            <div class="match-name ml-16">{{ matchInfo.away_name }}</div>
        </div>
        <div class="match-tips" v-if="showMatchTip">赛事实况</div>
    </div>
</template>

<script>
export default {
    props: {
        matchInfo: {
            type: Object,
            default: {}
        },
        showMatchTip: {
            type: Boolean,
            default: () => {
                return false
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.match-info {
    width: 100%;
    height: 64px;
    margin-bottom: 16px;
    background: #2a2d38;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    position: relative;

    .match-tips {
        width: 96px;
        height: 32px;
        background: rgba(38, 217, 157, 0.1);
        border: 1px solid #0dc286;
        border-radius: 16px;
        position: absolute;
        top: 50%;
        right: 16px;
        transform: translateY(-50%);
        font-size: 16px;
        color: #26d99d;
        letter-spacing: 0;
        text-align: center;
        line-height: 32px;
    }

    .match-content {
        width: 100%;
        height: 64px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .match-name {
        width: 160px;
        line-height: 22px;
        font-size: 16px;
        color: #ffffff;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .home-name {
        text-align: right;
        margin-right: 16px;
    }

    .match-score {
        width: 45px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        font-size: 24px;
        color: #ffffff;
        font-weight: 500;
    }

    .mr-16 {
        margin-right: 16px;
    }

    .ml-16 {
        margin-left: 16px;
    }

    .img-48 {
        width: 48px;
        height: 48px;
    }

    .info-center {
        width: 220px;
        height: 42px;
        line-height: 18px;
        margin-left: 24px;
        margin-right: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
    }

    .time-name {
        max-width: 220px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #ffffff;

        .time-date {
            width: 75px;
            margin-right: 8px;
        }

        .time-event-name {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .surplus-time {
        font-size: 14px;
        color: #dcb273;
    }
}
</style>